import type { Locale } from 'date-fns';
import enUsLocale from 'date-fns/locale/en-US';

import { formatLong } from './formatLong';
import { formatRelative } from './formatRelative';
import { localize } from './localize';

/**
 * Filipino locale adapted from date-fns v2.28.0. This locale is not supported
 * in v2.29.3
 * See https://github.com/date-fns/date-fns/tree/v2.28.0/src/locale/fil
 * @type {Locale}
 * @category Locales
 * @summary Filipino locale.
 * @language Filipino
 * @iso-639-2 fil
 * @author Ian De La Cruz [@RIanDeLaCruz]{@link https://github.com/RIanDeLaCruz}
 */
export const filLocale: Locale = {
  code: 'fil',
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
};
